export enum SubscriptionFrequency {
  M = 'Mensal',
  TM = 'Trimestral',
  SM = 'Semestral',
  Y = 'Anual',
  P = 'Personalizado',
}
